import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

const AddPart = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const imageStorageKey = "8a2fd622b09fe164cd5a3cd0097a5b35";

  const onSubmit = async (data) => {
    const image = data.image[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStorageKey}`;
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          const img = result.data.url;
          const part = {
            name: data.name,
            price: data.price,
            quantity: data.quantity,
            description: data.description,
            img: img,
          };
          // send to your database
          fetch("https://mbababd24.onrender.com/part", {
            method: "POST",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify(part),
          })
            .then((res) => res.json())
            .then((inserted) => {
              if (inserted.insertedId) {
                toast.success("Parts added successfully");
                reset();
              } else {
                toast.error("Failed to add the Parts");
              }
            });
        }
      });
  };

  return (
    <div className="flex justify-center items-center">
      <div className="card p-10 w-96 shadow-2xl border-2 border-white mx-4 mb-10">
        <h2 className="text-2xl text-center text-accent">Add a New Product</h2>
        <div className="text-center text-accent">
          <form onSubmit={handleSubmit(onSubmit)} className="text-center">
            <div className="form-control w-full max-w-xs mx-auto">
              <label className="label">
                <span className="label-text">Name</span>
              </label>
              <input
                type="text"
                placeholder="Your Name"
                className="input input-bordered w-full max-w-xs mx-auto"
                {...register("name", {
                  required: {
                    value: true,
                    message: "Name is Required",
                  },
                })}
              />
              <label className="label">
                {errors.name?.type === "required" && (
                  <span className="label-text-alt text-red-500">
                    {errors.name.message}
                  </span>
                )}
              </label>
            </div>

            <div className="form-control w-full max-w-xs mx-auto">
              <label className="label">
                <span className="label-text">Price</span>
              </label>
              <input
                type="text"
                placeholder="Parts Price"
                className="input input-bordered w-full max-w-xs mx-auto"
                {...register("price", {
                  required: {
                    value: true,
                    message: "Price is Required",
                  },
                  pattern: {
                    value: /^(0|[1-9]\d*)(\.\d+)?$/,
                    message: "Enter parts price",
                  },
                })}
              />
              <label className="label">
                {errors.price?.type === "required" && (
                  <span className="label-text-alt text-red-500">
                    {errors.price.message}
                  </span>
                )}
              </label>
              {errors.price?.type === "pattern" && (
                <span className="label-text-alt text-red-500">
                  {errors.price.message}
                </span>
              )}
            </div>
            <div className="form-control w-full max-w-xs mx-auto">
              <label className="label">
                <span className="label-text">Quantity</span>
              </label>
              <input
                type=""
                placeholder="Parts quantity"
                className="input input-bordered w-full max-w-xs mx-auto"
                {...register("quantity", {
                  required: {
                    value: true,
                    message: "quantity is Required",
                  },
                  pattern: {
                    value: /^(0|[1-9]\d*)(\.\d+)?$/,
                    message: "Enter valid parts quantity",
                  },
                })}
              />
              <label className="label">
                {errors.quantity?.type === "required" && (
                  <span className="label-text-alt text-red-500">
                    {errors.quantity.message}
                  </span>
                )}
              </label>
              {errors.quantity?.type === "pattern" && (
                <span className="label-text-alt text-red-500">
                  {errors.quantity.message}
                </span>
              )}
            </div>
            <div className="form-control w-full max-w-xs mx-auto">
              <label className="label">
                <span className="label-text">Description</span>
              </label>
              <textarea
                type="textarea"
                placeholder="Your Review"
                className="textarea textarea-bordered w-full max-w-xs mx-auto "
                {...register("description", {
                  required: {
                    value: true,
                    message: "Description is Required",
                  },
                })}
              />
              <label className="label">
                {errors.description?.type === "required" && (
                  <span className="label-text-alt text-red-500">
                    {errors.description.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control w-full max-w-xs mx-auto">
              <label className="label">
                <span className="label-text">Photo</span>
              </label>
              <input
                type="file"
                className="input input-bordered w-full max-w-xs mx-auto"
                {...register("image", {
                  required: {
                    value: true,
                    message: "Image is Required",
                  },
                })}
              />
              <label className="label">
                {errors.image?.type === "required" && (
                  <span className="label-text-alt text-red-500">
                    {errors.image.message}
                  </span>
                )}
              </label>
            </div>

            <input
              className="btn w-full max-w-xs mx-auto bg-secondary text-accent border-2 border-white shadow-2xl "
              type="submit"
              value="Add"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPart;
